import { Box } from "@mui/material";

interface ISpacerProps {
  data: any;
  renderOptions: ISpacerOptions;
}
interface ISpacerOptions {
  height?: string;
  width?: string;
}

export const Spacer = ({ renderOptions }: ISpacerProps) => {
  return (
    <>
      <Box
        sx={{
          height: renderOptions.height ?? "0",
          width: renderOptions.width ?? "0"
        }} />
    </>
  );
};
